// This will control the Drawer itself
class CollectionDrawer extends HTMLElement {
  constructor() {
      super();
      const overlayCloseSelector = document.querySelectorAll('.drawer__overlay')[0];
      const drawerCloseSelector = document.querySelectorAll('.drawer-drawer__close')[0];
      
      overlayCloseSelector.addEventListener('click', this.toggleFilters.bind(this));
      drawerCloseSelector.addEventListener('click', this.toggleFilters.bind(this));
  }

  toggleFilters(event) {
        event.preventDefault();
        const drawer = document.getElementById('filters-container');
        const overlay = document.querySelectorAll('.drawer__overlay')[0];
        overlay.classList.toggle('is-open');
        drawer.classList.toggle('is-open');
  }
}

customElements.define('filter-drawer', CollectionDrawer);

// This will control the Drawer Selector
class FilterButton extends HTMLElement {
  constructor() {
      super();
      const triggerSelector = this.querySelector('#main-collection-filters');
      
      triggerSelector.addEventListener('click', this.openDrawer.bind(this));
  }

  openDrawer(event) {
        event.preventDefault();
        const drawer = document.getElementById('filters-container');
        const overlay = document.querySelectorAll('.drawer__overlay')[0];
        overlay.classList.toggle('is-open');
        drawer.classList.toggle('is-open');
  }
}

customElements.define('filter-button', FilterButton);